export default __webpack_public_path__ + "static/TSD_Wrapping_Header-d5dd715c55afa166ab5f0eacab463b98.jpg";